import { render, staticRenderFns } from "./PieWidgetChart.vue?vue&type=template&id=fbc2127e"
import script from "./PieWidgetChart.vue?vue&type=script&lang=js"
export * from "./PieWidgetChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports